<template>
  <v-container class="pa-6" style="max-width: 640px">
    <v-card class="pa-4">
      <v-card-title>Suporte SCN Revolution</v-card-title>
      <v-card-text>
        <p>
          Precisa de ajuda com sua conta, saldo, pagamentos ou qualquer outra
          questão do app? Estamos aqui pra te ajudar.
        </p>

        <h3 class="mt-4">Abrir um chamado (recomendado)</h3>
        <p>
          Se você já tem conta, a forma mais rápida de resolver é abrir um
          chamado direto pelo app ou pelo portal, em
          <strong>Suporte</strong>.
        </p>
        <v-btn color="primary" href="https://cliente.scn.app.br/#/tickets">
          Abrir chamado
        </v-btn>

        <h3 class="mt-4">Não consegue acessar sua conta?</h3>
        <p>
          Entre em contato pelos canais abaixo, informando o e-mail ou CPF
          cadastrado:
        </p>
        <p>
          E-mail:
          <a href="mailto:suporte@scn.app.br">suporte@scn.app.br</a><br />
          Telefone/WhatsApp: (11) 98988-4869
        </p>

        <h3 class="mt-4">Outros assuntos</h3>
        <p>
          Dúvidas sobre privacidade e dados pessoais (LGPD): veja nossa
          <a href="https://cliente.scn.app.br/#/politica-de-privacidade">Política de Privacidade</a>
          ou escreva para
          <a href="mailto:lgpd@scnrevolution.com">lgpd@scnrevolution.com</a>.
        </p>
        <p>
          Para excluir sua conta, acesse a página de
          <a href="https://cliente.scn.app.br/#/excluir-conta">Exclusão de conta</a>.
        </p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Support"
};
</script>
